/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { auth } from '../../../../app/services/FirebaseClient';

import { useAppSelector } from '../../../../app/hooks/useRedux';

// image
import logoImage from '../../../../assets/image/scarlett-logo.png';
import Cookies from 'js-cookie';

const HeaderUserMenu: FC = () => {
  const { user, access } = useAppSelector((state) => state.auth);

  const handleLogout = () => {
    auth.signOut();
    Cookies.remove('token');
    localStorage.removeItem('access');
    window.location.href = '/auth';
  };

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img src={logoImage} alt='profile' />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{access.name}</div>
            <a
              href='#'
              className='fw-bold text-muted text-hover-primary fs-7'
              title={user.email}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '150px',
              }}
            >
              {user.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a href='/change-password' className='menu-link px-5'>
          Change Password
        </a>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={handleLogout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
